import { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Login() {
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [isSignUp, setIsSignUp] = useState(false);
const [isForgot, setIsForgot] = useState(false);
const [loading, setLoading] = useState(false);
const [error, setError] = useState('');
const [resetSent, setResetSent] = useState(false);

const mn = "'DM Mono',monospace";
const inputStyle = {width:"100%",background:"#181b24",border:"1px solid #2a2e3d",borderRadius:6,padding:"10px 12px",color:"#e8e9ed",fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif",marginTop:4,boxSizing:"border-box"};

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);
  setError('');
  const { error: err } = isSignUp
    ? await supabase.auth.signUp({ email, password })
    : await supabase.auth.signInWithPassword({ email, password });
  if (err) setError(err.message);
  setLoading(false);
}

async function handleReset(e) {
  e.preventDefault();
  if (!email.trim()) { setError('Enter your email address'); return; }
  setLoading(true);
  setError('');
  const { error: err } = await supabase.auth.resetPasswordForEmail(email.trim(), {
    redirectTo: 'https://misefoods.com'
  });
  if (err) { setError(err.message); }
  else { setResetSent(true); }
  setLoading(false);
}

if (isForgot) return (
<div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",padding:16,background:"#0f1117",fontFamily:"'DM Sans','Helvetica Neue',sans-serif"}}>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet"/>
<div style={{width:"100%",maxWidth:340,padding:"48px 28px",background:"#1c1f2b",borderRadius:16,border:"1px solid #2a2e3d"}}>
  <div style={{textAlign:"center",marginBottom:36}}>
    <div style={{fontFamily:mn,fontSize:36,fontWeight:700,letterSpacing:4,color:"#c8372d"}}>MISE</div>
    <div style={{fontSize:9,color:"#5d6174",letterSpacing:2,marginTop:2}}>EN PLACE</div>
  </div>
  {resetSent ? (
    <div style={{textAlign:"center"}}>
      <div style={{fontSize:14,fontWeight:600,color:"#2db87a",marginBottom:12}}>Reset email sent</div>
      <div style={{fontSize:12,color:"#8b8f9e",lineHeight:1.5,marginBottom:20}}>Check your inbox for a password reset link. It may take a minute to arrive.</div>
      <button onClick={()=>{setIsForgot(false);setResetSent(false);setError('');}} style={{background:"none",border:"none",color:"#8b8f9e",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Back to sign in</button>
    </div>
  ) : (
    <form onSubmit={handleReset}>
      <div style={{fontSize:13,color:"#e8e9ed",marginBottom:14,fontWeight:500}}>Reset your password</div>
      <div style={{fontSize:11,color:"#8b8f9e",marginBottom:16,lineHeight:1.4}}>Enter your email and we'll send you a link to reset your password.</div>
      <div style={{marginBottom:20}}>
        <label style={{fontSize:9,color:"#5d6174",textTransform:"uppercase",letterSpacing:1}}>Email</label>
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required style={inputStyle}/>
      </div>
      {error&&<div style={{fontSize:11,color:"#c8372d",marginBottom:12}}>{error}</div>}
      <button type="submit" disabled={loading} style={{width:"100%",border:"none",borderRadius:8,padding:"12px",fontSize:13,fontWeight:600,cursor:loading?"wait":"pointer",color:"#fff",background:"#c8372d",fontFamily:"'DM Sans',sans-serif",opacity:loading?0.6:1}}>{loading?"...":"Send Reset Link"}</button>
      <div style={{textAlign:"center",marginTop:16}}>
        <button onClick={()=>{setIsForgot(false);setError('');}} type="button" style={{background:"none",border:"none",color:"#8b8f9e",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Back to sign in</button>
      </div>
    </form>
  )}
</div>
</div>
);

return (
<div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",padding:16,background:"#0f1117",fontFamily:"'DM Sans','Helvetica Neue',sans-serif"}}>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet"/>
<div style={{width:"100%",maxWidth:340,padding:"48px 28px",background:"#1c1f2b",borderRadius:16,border:"1px solid #2a2e3d"}}>
  <div style={{textAlign:"center",marginBottom:36}}>
    <div style={{fontFamily:mn,fontSize:36,fontWeight:700,letterSpacing:4,color:"#c8372d"}}>MISE</div>
    <div style={{fontSize:9,color:"#5d6174",letterSpacing:2,marginTop:2}}>EN PLACE</div>
  </div>
  <form onSubmit={handleSubmit}>
    <div style={{marginBottom:14}}>
      <label style={{fontSize:9,color:"#5d6174",textTransform:"uppercase",letterSpacing:1}}>Email</label>
      <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required style={inputStyle}/>
    </div>
    <div style={{marginBottom:8}}>
      <label style={{fontSize:9,color:"#5d6174",textTransform:"uppercase",letterSpacing:1}}>Password</label>
      <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required minLength={6} style={inputStyle}/>
    </div>
    {!isSignUp&&<div style={{textAlign:"right",marginBottom:14}}>
      <button onClick={()=>{setIsForgot(true);setError('');}} type="button" style={{background:"none",border:"none",color:"#8b8f9e",fontSize:10,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>Forgot password?</button>
    </div>}
    {isSignUp&&<div style={{height:12}}/>}
    {error&&<div style={{fontSize:11,color:"#c8372d",marginBottom:12}}>{error}</div>}
    <button type="submit" disabled={loading} style={{width:"100%",border:"none",borderRadius:8,padding:"12px",fontSize:13,fontWeight:600,cursor:loading?"wait":"pointer",color:"#fff",background:"#c8372d",fontFamily:"'DM Sans',sans-serif",opacity:loading?0.6:1}}>{loading?"...":(isSignUp?"Create Account":"Sign In")}</button>
  </form>
  <div style={{textAlign:"center",marginTop:16}}>
    <button onClick={()=>{setIsSignUp(!isSignUp);setError('');}} style={{background:"none",border:"none",color:"#8b8f9e",fontSize:11,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>{isSignUp?"Already have an account? Sign in":"Need an account? Sign up"}</button>
  </div>
</div>
</div>
);
}
